import { useEffect, useRef, useState } from "react";

const NOTES = ["♪", "♫", "♩", "♬"];

export default function CursorNotes() {
  const [notes, setNotes] = useState([]);
  const lastSpawn = useRef(0);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    if (window.matchMedia("(hover: none), (pointer: coarse)").matches) return undefined;
    let id = 0;
    const timers = [];
    const onMove = (e) => {
      const now = performance.now();
      if (now - lastSpawn.current < 110) return;
      lastSpawn.current = now;
      const note = {
        id: id++,
        x: e.clientX,
        y: e.clientY,
        char: NOTES[id % NOTES.length],
        size: 12 + (id % 3) * 3,
        drift: Math.round((Math.random() - 0.5) * 44),
        dur: 0.8 + Math.random() * 0.4,
      };
      setNotes((n) => [...n.slice(-14), note]);
      timers.push(setTimeout(() => setNotes((n) => n.filter((m) => m.id !== note.id)), 1300));
    };
    window.addEventListener("mousemove", onMove);
    return () => {
      window.removeEventListener("mousemove", onMove);
      timers.forEach(clearTimeout);
    };
  }, []);

  return (
    <div className="cursor-notes" aria-hidden="true" data-testid="cursor-notes">
      {notes.map((n) => (
        <span
          key={n.id}
          className="cursor-note"
          style={{
            left: n.x,
            top: n.y,
            fontSize: n.size,
            "--drift": `${n.drift}px`,
            animationDuration: `${n.dur}s`,
          }}
        >
          {n.char}
        </span>
      ))}
    </div>
  );
}
